export { PhaseOperations } from '@/common/cms/modules/phaseOperations/module'
export { templatePhaseOperationsVue } from '@/common/cms/modules/phaseOperations/template/phaseOperations'
export { templatePhaseOperationsComplexVue } from '@/common/cms/modules/phaseOperations/template/phaseOperationsComplex'
export { templatePhaseOperationsSimplexVue } from '@/common/cms/modules/phaseOperations/template/phaseOperationsSimple'
